"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var components_1 = require("../components");
var components_2 = require("stremio/components");
var common_1 = require("stremio/common");
var Shortcuts_less_1 = __importDefault(require("./Shortcuts.less"));
var Shortcuts = (0, react_1.forwardRef)(function (_a, ref) {
    var _b = _a.embedded, embedded = _b === void 0 ? false : _b;
    var grouped = (0, common_1.useShortcuts)().grouped;
    var groups = (react_1.default.createElement(react_1.default.Fragment, null, grouped.map(function (_a) {
        var name = _a.name, label = _a.label, shortcuts = _a.shortcuts;
        return (react_1.default.createElement(components_2.ShortcutsGroup, { key: name, className: Shortcuts_less_1.default['shortcuts-group'], label: label, shortcuts: shortcuts }));
    })));
    return embedded ? react_1.default.createElement("div", { ref: ref }, groups) : react_1.default.createElement(components_1.Section, { ref: ref, label: 'SETTINGS_NAV_SHORTCUTS' }, groups);
});
exports.default = Shortcuts;
